// Fakta yang sudah dikonfirmasi. Isi null = belum dikasih Eki, bagian itu disembunyikan (jangan dikarang).
export const SITE = {
  foundedYear: 2021,
  projectsCount: 6, // Eki via chat 28 Okt: 5 freelance + 1 platform trading, semua anonim
  countries: 4, // Indonesia, Australia, Malaysia, Hong Kong (Eki, 29 Okt; bukan UK)
  phone: "+62 823 6462 9599",
  whatsapp: "6282364629599",
  email: "contactus@next-in.online",
};
